import React from 'react';

interface TreeErrorProps {
  error: string;
  onRetry: () => void;
  treeId?: string;
}

export const TreeError: React.FC<TreeErrorProps> = ({ error, onRetry, treeId }) => {
  return (
    <div className="error-container">
      <div className="error-content">
        <h2>Error Loading Skill Tree</h2>
        {treeId && <p className="tree-id">Tree: {treeId}</p>}
        <p className="error-message">{error}</p>
        <div className="error-actions">
          <button onClick={onRetry} className="btn btn-primary">
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};
